import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { Tag } from '@app/core/business/product/tag';
import { environment } from '@env/environment';

@Component({
  selector: 'app-tag-label',
  templateUrl: './tag-label.component.html',
  styleUrls: ['./tag-label.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TagLabelComponent {
  @Input()
  tag: Tag;

  public env = environment;

  constructor() {}
}
